import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoCreatorInfo,
    RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn, RaikoGridTwoColumn, RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";
import {useEffect, useState} from "react";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import {GameTeamService} from "../../serverService/gameService/GameTeamService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {GameTeamStatusType} from "../gameTeams/GameTeamStatusType";
import GameTeamMembers from "../gameTeamMembers/GameTeamMembers";

export default function GameTeamDetails() {

    const location = useLocation()

    const {gamePeriodId, gameTeamId} = useParams()

    console.log("gamePeriodId", gamePeriodId)
    console.log("gameTeamId", gameTeamId)

    const {gamePeriodTitle, gameTeamTitle} = location.state || {}


    const navigate = useNavigate()
    const [tabSelectedValue, setTabSelectedValue] = useState(gameTeamDetailsTabType.basicInfo.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    //basic-information

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameTeamDetailsFromServer()
            getGameTeamStatusFromServer()
        }
    }, []);

    const service = new GameTeamService();
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [teamTitle, setTeamTitle] = useState("");
    const [numberOfMembers, setNumberOfMembers] = useState(0)
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [updatedBy, setUpdatedBy] = useState("");
    const [updatedAt, setUpdatedAt] = useState("");

    const [updateButtonLoading, setUpdateButtonLoading] = useState(false)

    function getGameTeamDetailsFromServer() {
        loading.show()
        service.getTeamInfo(gameTeamId)
            .then(response => {
                setTeamTitle(response.title)
                setNumberOfMembers(response.numberOfMembers)
                setCreatedBy(response.createdBy)
                setUpdatedAt(convertUniversalDateTimeToPersianDateTime(response.updatedAt))
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setUpdatedBy(response.updatedBy)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    function updateGameTeamDetails() {
        setUpdateButtonLoading(true)
        service.updateTeamInfo(gameTeamId, teamTitle)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setUpdateButtonLoading(false)
        })
    }

    //basic-information

    //admission-settings
    const [teamStatus, setTeamStatus] = useState(GameTeamStatusType.ACTIVE.id)

    function getGameTeamStatusFromServer() {
        loading.show()
        service.getAdmissionSettings(gameTeamId)
            .then(response => {
                setTeamStatus(response.status)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })

    }

    function updateGameTamStatus() {
        setUpdateButtonLoading(true)
        service.updateAdmissionSettings(gameTeamId, teamStatus)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setUpdateButtonLoading(false)
        })

    }

    //admission-settings

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.Game.name,
                            "",
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.GamePeriod.name,
                            RouteHelper.GamePeriod.globalUrl,
                        ),
                        raikoBreadCrumbItemGenerator(
                            gamePeriodTitle,
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            gameTeamTitle,
                            ""
                        )
                    ]}/>
                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(-1)
                        }}
                    />
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={gameTeamDetailsTabType.basicInfo.title}
                                value={gameTeamDetailsTabType.basicInfo.id}
                            />
                            <Tab
                                label={gameTeamDetailsTabType.admissionSettings.title}
                                value={gameTeamDetailsTabType.admissionSettings.id}
                            />
                            <Tab
                                label={gameTeamDetailsTabType.teamMembers.title}
                                value={gameTeamDetailsTabType.teamMembers.id}
                            />
                        </TabList>
                    </Box>
                    <TabPanel value={gameTeamDetailsTabType.basicInfo.id}>
                        <RaikoGridOneColumn>
                            <RaikoBaseCardContainer>
                                <RaikoSectionContainer
                                    title={"اطلاعات پایه"}
                                    hasActionButton
                                    actionButtonLoadingState={updateButtonLoading}
                                    actionButtonOnclickWithValidation={updateGameTeamDetails}
                                >
                                    <RaikoGridTwoColumn>
                                        <RaikoSimpleInputOutlined
                                            labelText={"عنوان تیم"}
                                            value={teamTitle}
                                            setValue={setTeamTitle}
                                            required
                                        />
                                        <RaikoNumberInputOutlined
                                            labelText={"تعداد بازیکن"}
                                            value={numberOfMembers}
                                            setValue={setNumberOfMembers}
                                            disabled
                                        />
                                    </RaikoGridTwoColumn>

                                </RaikoSectionContainer>
                            </RaikoBaseCardContainer>
                            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
                            <RaikoCreatorInfo
                                title={"آخرین بروزرسانی"}
                                createdByTitle={"ادمین"}
                                createdBy={updatedBy}
                                createdAtTitle={"تاریخ بروزرسانی"}
                                createdAt={updatedAt}/>
                        </RaikoGridOneColumn>

                    </TabPanel>
                    <TabPanel value={gameTeamDetailsTabType.admissionSettings.id}>
                        <RaikoBaseCardContainer>
                            <RaikoSectionContainer
                                title={"وضعیت"}
                                hasActionButton
                                actionButtonLoadingState={updateButtonLoading}
                                actionButtonOnclick={updateGameTamStatus}
                            >
                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    value={teamStatus}
                                    setValue={setTeamStatus}
                                    items={[
                                        raikoCustomSelectItemGenerator(GameTeamStatusType.ACTIVE.id, GameTeamStatusType.ACTIVE.title),
                                        raikoCustomSelectItemGenerator(GameTeamStatusType.FORMING.id, GameTeamStatusType.FORMING.title),
                                        raikoCustomSelectItemGenerator(GameTeamStatusType.DISBANDED.id, GameTeamStatusType.DISBANDED.title),
                                        raikoCustomSelectItemGenerator(GameTeamStatusType.DISQUALIFIED.id, GameTeamStatusType.DISBANDED.title),
                                    ]}

                                />

                            </RaikoSectionContainer>
                        </RaikoBaseCardContainer>
                    </TabPanel>
                    <TabPanel value={gameTeamDetailsTabType.teamMembers.id}>
                        <GameTeamMembers gameTeamId={gameTeamId}/>
                    </TabPanel>

                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}

const gameTeamDetailsTabType = {
    basicInfo: {
        id: "basicInfo",
        title: "اطلاعات پایه",
    },
    admissionSettings: {
        id: "admissionSettings",
        title: "وضعیت",
    },
    teamMembers: {
        id: "teamMember",
        title: "بازیکنان",
    }
}